export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.15-1512.37",
  commitId: "966c44e8fab75682206e6ae733f5394f6923b44d",
  commitTime: "2026-05-15T15:12:37.000Z",
});
